export const IMPORT_VISITORS_REQUIRED_HEADERS = ['First Name', 'Last Name', 'Email'] as const;

export const IMPORT_VISITORS_OPTIONAL_HEADERS = {
  language: 'Language (en/pl)',
  isHandicapped: 'Handicapped (yes/no)',
  isPregnant: 'Pregnant (yes/no)',
  hasPet: 'Pet (yes/no)',
  hasAccessToParking: 'Parking (yes/no)',
} as const;

const IMPORT_VISITORS_TEMPLATE_EXAMPLE_VALUES = {
  [IMPORT_VISITORS_REQUIRED_HEADERS[0]]: 'Sample',
  [IMPORT_VISITORS_REQUIRED_HEADERS[1]]: 'Visitor',
  [IMPORT_VISITORS_REQUIRED_HEADERS[2]]: 'visitor@example.com',
  [IMPORT_VISITORS_OPTIONAL_HEADERS.language]: 'en',
  [IMPORT_VISITORS_OPTIONAL_HEADERS.isHandicapped]: 'no',
  [IMPORT_VISITORS_OPTIONAL_HEADERS.isPregnant]: 'no',
  [IMPORT_VISITORS_OPTIONAL_HEADERS.hasPet]: 'no',
  [IMPORT_VISITORS_OPTIONAL_HEADERS.hasAccessToParking]: 'no',
} as const;

export const createImportVisitorsTemplateHeaders = (allowInviteToParking: boolean) => [
  ...IMPORT_VISITORS_REQUIRED_HEADERS,
  IMPORT_VISITORS_OPTIONAL_HEADERS.language,
  IMPORT_VISITORS_OPTIONAL_HEADERS.isHandicapped,
  IMPORT_VISITORS_OPTIONAL_HEADERS.isPregnant,
  IMPORT_VISITORS_OPTIONAL_HEADERS.hasPet,
  ...(allowInviteToParking ? [IMPORT_VISITORS_OPTIONAL_HEADERS.hasAccessToParking] : []),
];

export const createImportVisitorsTemplateExampleRow = (allowInviteToParking: boolean) =>
  createImportVisitorsTemplateHeaders(allowInviteToParking).map(
    header => IMPORT_VISITORS_TEMPLATE_EXAMPLE_VALUES[header],
  );
